import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function CircularIndeterminate({height="100vh"}) {
  return (
    <Box sx={{ display: 'flex',justifyContent:"center",alignItems:"center",height:height }}>
      <CircularProgress />
    </Box>
  );
}